import { apiUrl } from '../config/api'

// List shop<->category mappings; optionally filter by shopId
export async function listShopTagMappings(params = {}) {
  const qs = new URLSearchParams()
  if (params.shopId) qs.set('shopId', String(params.shopId))
  const url = apiUrl(`/api/main-categories/map${qs.toString() ? `?${qs.toString()}` : ''}`)
  const res = await fetch(url, { headers: { Accept: 'application/json' }, credentials: 'include' })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

// Create mapping between a shop and a category
export async function createShopTagMapping(payload) {
  // payload: { shopId, categoryId } (or tagId for backward compat)
  const body = { ...payload }
  if (body.tagId && !body.categoryId) body.categoryId = body.tagId
  const res = await fetch(apiUrl('/api/main-categories/map'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    credentials: 'include',
    body: JSON.stringify(body),
  })
  if (!res.ok) throw new Error(await res.text())
  return res.json()
}

// Delete mapping between a shop and a category
export async function deleteShopTagMapping(shopId, tagId) {
  const qs = new URLSearchParams({ shopId: String(shopId), categoryId: String(tagId) })
  const res = await fetch(apiUrl(`/api/main-categories/map?${qs.toString()}`), {
    method: 'DELETE',
    credentials: 'include',
  })
  if (!res.ok) throw new Error(await res.text())
  return true
}
